import request from "@/utils/request";

let FengkongApi = {
  /*获取风控报告列表*/
  riskList(data, errorback) {
    return request._post("/shop/riskmanagement.risk/list", data, errorback);
  },

  /*风控报告添加*/
  riskAdd(data, errorback) {
    return request._post("/shop/riskmanagement.risk/index", data, errorback);
  },

  /*生成授权书*/
  createAuthorization(data, error) {
    return request._post(
      "/shop/order.contract/createByDocTemplate2",
      data,
      error
    );
  },

  /*风控报告删除*/
  riskDelete(data, errorback) {
    return request._post("/shop/riskmanagement.risk/delete", data, errorback);
  },
  /*风控报告详情*/
  riskDetail(data, errorback) {
    return request._post("/shop/riskmanagement.risk/details", data, errorback);
  },
  /*风控报告详情用户id查询*/
  detailsUser(data, errorback) {
    return request._post(
      "/shop/riskmanagement.risk/detailsUser2",
      data,
      errorback
    );
  },
  /*征信报告详情用户id查询*/
  zhengxin(data, errorback) {
    return request._post("/shop/yunxin.query/testBooleanDemo", data, errorback);
  },
  /*pdf查询*/
  pdf(data, errorback) {
    return request._post(
      "/shop/riskmanagement.risk/createpdf",
      data,
      errorback
    );
  },
  /*蚂盾*/
  yidun(data, errorback) {
    return request._post("/shop/mayilian.yidun/main", data, errorback);
  },
  /*查询代扣规则列表*/
  daikouguize(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/queryTheListOfWithholdingRules",
      data,
      errorback
    );
  },
  /*蚂蚁链代扣回调列表*/
  mayiliandaikouhui(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/listFeedback",
      data,
      errorback
    );
  },
  /*取消某一期的代扣规则条目*/
  quxiaotiaomu(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/cancelTheWithholdingRuleEntryOfACertainPeriod",
      data,
      errorback
    );
  },
  /*生成天狼星报告星耀版*/
  tianlangxing(data, errorback) {
    return request._post("/shop/yunxin.query/siriusReport", data, errorback);
  },
  /*创建合同*/
  chuangjianhetong(data, errorback) {
    return request._post("/shop/mayilian.mayilian/index", data, errorback);
  },
  /*取消代扣*/
  cancelDaikou(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/cancelTheWithholdingRuleEntryOfACertainPeriod2",
      data,
      errorback
    );
  },
  /*手动扣款*/
  withholdingTrigger(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/withholdingTrigger",
      data,
      errorback
    );
  },
  //短信发送记录列表
  duanxin(data, errorback) {
    return request._post("/shop/user.smslog/index", data, errorback);
  },
  //短信发送记录修改
  xiugai(data, errorback) {
    return request._post("/shop/user.smslog/edit", data, errorback);
  },
  //短信发送记录删除
  shanchu(data, errorback) {
    return request._post("/shop/user.smslog/delete", data, errorback);
  },
  //贷款报告
  daikuan(data, errorback) {
    return request._post(
      "/shop/yunxin.Query3/testBooleanDemo",
      data,
      errorback
    );
  },
  //逾期报告
  yuqi(data, errorback) {
    return request._post(
      "/shop/yunxin.Query4/testBooleanDemo",
      data,
      errorback
    );
  },
  //短信发送记录添加
  duanxintianjia(data, errorback) {
    return request._post("/shop/user.smslog/add", data, errorback);
  },
  //蚂蚁链代扣退款
  withholdingRefund(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/withholdingRefund",
      data,
      errorback
    );
  },
  //查询代扣退款
  withholdingRefund(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/withholdingRefund",
      data,
      errorback
    );
  },
  //爱签合同
  createaq(data, errorback) {
    return request._post("/shop/aiqian.aiqian/create", data, errorback);
  },
  // e签宝合同
  createEqb(data, errorback) {
    return request._post(
      "/shop/order.contract/createByDocTemplate",
      data,
      errorback
    );
  },
  /*征信*/
  trade(data, errorback) {
    return request._post("/shop/zhangqian.query/trade", data, errorback);
  },
  /*开户*/
  open(data, errorback) {
    return request._post("/shop/zhangqian.query/open", data, errorback);
  },
  /*结清*/
  close(data, errorback) {
    return request._post("/shop/zhangqian.query/close", data, errorback);
  },
  /*逾期*/
  csdefault(data, errorback) {
    return request._post("/shop/zhangqian.query/csdefault", data, errorback);
  },
  /*资料上传*/
  upzl(data, errorback) {
    return request._post("/shop/zhangqian.query/upzl", data, errorback);
  },
  /*逾期资料上传*/
  upyqzl(data, errorback) {
    return request._post("/shop/zhangqian.query/upyqzl", data, errorback);
  },
  //静默签
  hrzxqs(data, errorback) {
    return request._post("/shop/aiqian.aiqian/hrzxqs", data, errorback);
  },
  // 赋强公证获取token
  getToken(data, errorback) {
    return request._post("/shop/gongzheng.index/getToken", data, errorback);
  },
  // 赋强公证申请
  createApply(data, errorback) {
    return request._post("/shop/gongzheng.index/createApply", data, errorback);
  },
  // 顺丰生成二维码
  getQrcode(data, errorback) {
    return request._post("/shop/order.order/getQrcode", data, errorback);
  },
  // 测试
  createApply1(data, errorback) {
    return request._post("/shop/gongzheng.index/createApply", data, errorback);
  },
  // 申请公证
  createOrder(data, errorback) {
    return request._post("/shop/lujiang.index/createOrder", data, errorback);
  },
  // 取消申请公证
  cancleOrder(data, errorback) {
    return request._post("/shop/lujiang.index/cancleOrder", data, errorback);
  },
  // 申请出证
  applyCert(data, errorback) {
    return request._post("/shop/lujiang.index/applyCert", data, errorback);
  },
  // 出证刷新
  getOrderInfo(data, errorback) {
    return request._post("/shop/lujiang.index/getOrderInfo", data, errorback);
  },
  // 静默签署
  silenceSign(data, errorback) {
    return request._post("/shop/lujiang.index/silenceSign", data, errorback);
  },
  // 下载公证书
  downNotaryOrder(data, errorback) {
    return request._post("/shop/lujiang.index/downNotary", data, errorback);
  },
  // 获取二维码
  getQrinfo2(data, errorback) {
    return request._post("/shop/lujiang.index/getQrinfo2", data, errorback);
  },
  // 撤销公证
  applyCert(data, errorback) {
    return request._post("/shop/lujiang.index/applyCert", data, errorback);
  }
};

export default FengkongApi;



// WEBPACK FOOTER //
// ./src/api/fengkong.js